export default __webpack_public_path__ + "media/images/images_v2/iui/pinstripes-41c73e4c24215a15f22273c32f7cb761.png";